import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Spending, CreateSpendingDto, UpdateSpendingDto, SpendingSummary } from '../models/spending.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class SpendingService {
  private http = inject(HttpClient);
  private base = `${apiBase}/spending`;

  getAll(from?: string, to?: string): Observable<Spending[]> {
    let params = new HttpParams();
    if (from) params = params.set('from', from);
    if (to) params = params.set('to', to);
    return this.http.get<Spending[]>(this.base, { params });
  }

  getById(id: number): Observable<Spending> {
    return this.http.get<Spending>(`${this.base}/${id}`);
  }

  getSummary(from?: string, to?: string, groupBy = 'category'): Observable<SpendingSummary[]> {
    let params = new HttpParams().set('groupBy', groupBy);
    if (from) params = params.set('from', from);
    if (to) params = params.set('to', to);
    return this.http.get<SpendingSummary[]>(`${this.base}/summary`, { params });
  }

  create(dto: CreateSpendingDto): Observable<Spending> {
    return this.http.post<Spending>(this.base, dto);
  }

  update(id: number, dto: UpdateSpendingDto): Observable<Spending> {
    return this.http.put<Spending>(`${this.base}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
